import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

class TicketListing extends Component {

  handleChange(event) {
    event.preventDefault();
    //const ticket = this.getTicket();
    //ticket.quantity = event.target.value;
    const { store, ticketId } = this.props;
    store.changeTicketQuantity(ticketId, event.target.value);
  }

  getTicket() {
    const { ticketId } = this.props;
    const { tickets } = this.props.store;
    return tickets.get(ticketId);
  }

  render() {
    const ticketIconUrl = 'https://my.kabbalah.com/ticket-widget/media/ticket-icon.png';
    const { ticketId, store } = this.props;
    const { customer } = store;
    const ticket = this.getTicket();    
    let quantityDisabled = ticket.usedCommunityDiscount;
    return (
      <li className="list-group-item">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-3 col-md-1 d-none d-md-block text-center">
              <img width="50px" src={ticketIconUrl} alt="" />
            </div>
            <div className="col-10 col-md-5">
              <p>{ticket.name}
                {(customer.hasCommunitySubscription && !ticket.usedCommunityDiscount && 
                    ticket.price > 0) &&                               
                  <small className="text-success">
                    <br />
                    Community Member: First ticket is free.
                  </small> 
                } 
                {(customer.hasCommunitySubscription && ticket.usedCommunityDiscount && 
                    ticket.price > 0) &&                               
                  <small className="text-danger">
                    <br />
                    Community Member: Already claimed free ticket.
                  </small> 
                }                 
              </p>            
            </div>
            <div className="col-2 d-block d-md-none text-right align-self-start">
              <img width="50px" src={ticketIconUrl} alt="" />
            </div>            
            <div className="col-3 col-md-2 text-md-center">
              <p>
                {/*<span className="d-inline d-md-none font-weight-light">quantity:&nbsp;</span>*/}
                <select                   
                  value={ticket.quantity} 
                  disabled={quantityDisabled}
                  className="form-control form-control-lg" 
                  style={{ width: '65px', display: 'inline' }}
                  onChange={this.handleChange.bind(this)}
                >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  {/*<option value="2" disabled>2</option>
                  <option value="3" disabled>3</option>
                  <option value="4" disabled>4</option>
                  <option value="5" disabled>5</option>
                  <option value="6" disabled>6</option>
                  <option value="7" disabled>7</option>
                  <option value="8" disabled>8</option>
                  <option value="9" disabled>9</option>*/}                
                </select>
              </p>
            </div>
            <div className="col-5 col-md-2 text-right text-md-center">
              <p>
                {/*<span className="d-inline d-md-none font-weight-light">Price:&nbsp;</span>*/}
                USD ${ticket.price}
              </p>
            </div>
            <div className="col-md-2 text-md-center">
              <p>                
                {(ticket.quantity > 0) && 
                  <span>
                    <span className="d-inline d-md-none font-weight-light font-italic">
                      Total:&nbsp;
                    </span>
                    USD ${store.getLineItemTotal(ticketId)}
                  </span>
                }
              </p>
            </div>
          </div>
        </div>
      </li>
    );
  }

}

export default inject('store')(observer(TicketListing));



// WEBPACK FOOTER //
// ./src/components/TicketListing.js